<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import AvatarMenu from '@/components/navigation/AvatarMenu.vue';
import TopMenuBar from '@/components/navigation/TopMenuBar.vue';
import LanguageSwitcher from '@/components/navigation/LanguageSwitcher.vue';
import { useUserStore } from '@/stores/user';

const router = useRouter();
const user = useUserStore();

const isPoboxUser = computed(() => user.data?.user?.type === 'POBOX');

const goToGlobalSearch = () => {
    router.push({ name: 'globalSearch' });
};
</script>

<template>
    <v-app-bar
        color="secondary"
        prominent
        elevation="0"
        extension-height="70"
        density="compact"
        class="menubar"
    >
        <v-app-bar-nav-icon
            variant="text"
            @click.stop="$emit('toggleSidebar')"
        ></v-app-bar-nav-icon>

        <v-toolbar-title class="main-title">Trackingpremium</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
            v-if="!isPoboxUser"
            icon="mdi-magnify"
            variant="text"
            @click="goToGlobalSearch"
            class="me-2"
        ></v-btn>

        <LanguageSwitcher></LanguageSwitcher>
        <AvatarMenu></AvatarMenu>

        <template v-slot:extension>
            <TopMenuBar></TopMenuBar>
        </template>
    </v-app-bar>
</template>

<style lang="scss" scoped>
.v-toolbar.menubar {
    overflow: initial;
}
:deep(.v-toolbar__extension) {
    padding: 0px !important;
}

.main-title {
    font-weight: bold;
    font-size: 1.1rem;
}
</style>
